import * as React from 'react';
import { translate } from '../../translate-hoc';

// constants
import { TEXT_KEYS } from '../header-login.constants';

// types
import { ICustomLogoutProps, ICustomLogoutState } from './custom-logout.types';

import Link from 'components/link';
import { buildUserImageSrc } from 'utils/user-avatar';

// styles
import './custom-logout.styles.less';

export class CustomLogout extends React.Component<ICustomLogoutProps, ICustomLogoutState> {
    public state: ICustomLogoutState = {
        isOpen: false
    };

    private toggleDropdown = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };

    private renderDropdown(): JSX.Element | null {
        if (!this.state.isOpen) {
            return null; 
        }
        const {
            originalTranslateKey: translateKey,
            loginSession: { UbisoftConnectProfile: { user: { nameOnPlatform = '' } } }
        } = this.props;
        return (
            <div className="sitegen-logout__modal" onClick={this.toggleDropdown}>
                <div className="sitegen-logout__dropdown">
                    <div className="sitegen-logout__dropdown-item">
                        <span>{nameOnPlatform}</span>
                    </div>
                    <div className="sitegen-logout__dropdown-item" onClick={this.props.logOut}>
                        <Link>{translateKey(TEXT_KEYS.HEADER_LOGOUT)}</Link>
                    </div>
                </div>
            </div>
        );
    }

    private renderAvatarButton(): JSX.Element {
        const { config: { envName }, loginSession: { UbisoftConnectProfile: { user: { profileId } } } } = this.props;
        const style: React.CSSProperties = { backgroundImage: `url(${buildUserImageSrc(envName, profileId)})` };
        const { isOpen } = this.state;
        return (
            <div className={`sitegen-logout__button ${ isOpen ? 'open' : 'close'}`} onClick={this.toggleDropdown}>
                <div className="sitegen-logout__avatar" style={style}/>
            </div>);
    }

    public render(): JSX.Element {
        return <>
            {this.renderAvatarButton()}
            {this.renderDropdown()}
        </>;
    }
}

export default translate()(CustomLogout);
